<template>
  <Row>
    <table class="lida-leading-table " style="font-size: 12px;">
      <tbody>
        <tr>
          <router-link 
          tag="td" 
          v-for="(it, index) in topbarname" 
          :key="index" 
          style="padding: 2px 2px; width:6.1%" 
          :to="{path: `${it.to}`}"
          @click.native="!it.show && [15, 227].includes(getgameid) ? null : DefaultProj()"
          class="liveshowGameTabs-link"
          :class="{'liveshowGameTabs-link-disable': !it.show && [15, 227].includes(getgameid)}"
          :event="!it.show && [15, 227].includes(getgameid) ? '' : 'click'"
          >
            <Row type="flex" justify="space-between" align="middle">
              <i-Col class="box-tabs-gametext text-left">
                <p>{{it.name}}</p>
                <p>{{it.name2}}</p>
              </i-Col>
              <i-Col class="tr r " v-if="!isNaN(Number.parseInt(topbardata[it.key[0]]))">
                <p>{{ Number.parseInt(topbardata[it.key[0]]) | commaFormat}}</p>
                <p v-if="it.key.length == 2">{{ Number.parseInt(topbardata[it.key[1]]) | commaFormat}}</p>
              </i-Col>
            </Row>
          </router-link >
        </tr>
      </tbody>
    </table>
  </Row>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    props: {
        topbardata: {
            type: Object,
            required: true
        }
    },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['getliveshow', 'getgameid']),
    pathName () {
      return this.$route.matched[1].name
    },
    topbarname () {
      let array = [
        {
          name: "特",
          name2: "码",
          key: ["p1_1", "p1_2"],
          to: "scode",
          show: true
        },
        {
          key: ["p2"],
          name: "正",
          name2: "码",
          to: "pcode",
          show: true
        },
        {
          key: ["p3_1", "p3_2"],
          name: "正1",
          name2: "特",
          to: "pscode_1",
          show: false
        },
        {
          key: ["p4_1", "p4_2"],
          name: "正2",
          name2: "特",
          to: "pscode_2",
          show: false
        },
        {
          key: ["p5_1", "p5_2"],
          name: "正3",
          name2: "特",
          to: "pscode_3",
          show: false
        },
        {
          key: ["p6_1", "p6_2"],
          name: "正4",
          name2: "特",
          to: "pscode_4",
          show: false
        },
        {
          key: ["p7_1", "p7_2"],
          name: "正5",
          name2: "特",
          to: "pscode_5",
          show: false
        },
        {
          key: ["p8_1", "p8_2"],
          name: "正6",
          name2: "特",
          to: "pscode_6",
          show: false
        },
        {
          key: ["p9"],
          name: "生尾 ",
          name2: "肖量",
          to: "rawtail",
          show: true
        },
        {
          key: ["p10"],
          name: "连 ",
          name2: "码",
          to: "doublecode",
          show: true
        },
        {
          key: ["p11"],
          name: "生 ",
          name2: "连",
          to: "rawcontact",
          show: true
        },
        {
          key: ["p12"],
          name: "尾 ",
          name2: "连",
          to: "tailcontact",
          show: true
        },
        {
          key: ["p13"],
          name: "不 ",
          name2: "中",
          to: "donot",
          show: true
        },
        {
          key: ["p14"],
          name: "多选",
          name2: "中一",
          to: "selectonemore",
          show: true
        },
        {
          key: ["p15"],
          name: "特平",
          name2: "中",
          to: "special",
          show: true
        },
        {
          key: ["p16"],
          name: "其",
          name2: "他",
          to: "other",
          show: true
        }
      ]

      if ([78, 210, 212, 224, 228].includes(this.getgameid)) {
        array[8].name = "生"
        array[8].name2 = "尾"
      }

      return array
    }
  },
  created () {
    this.DefaultProj()
  },
  methods: {
    ...mapActions(['chg_liveshow_state']),
    DefaultProj () {
      if(this.getliveshow.proj != 1) this.chg_liveshow_state({ proj: 1 });
    }
  },
};
</script>
<style lang="scss">
.liveshowGameTabs-link {
  cursor: pointer;
  &-disable {
    background: #eee;
    cursor: not-allowed;
  }
}
</style>